module.exports = __webpack_public_path__ + "img/dripicons-v2.83598443.svg";